import { render, staticRenderFns } from "./KeyboxDetail.vue?vue&type=template&id=08256ce8&scoped=true"
import script from "./KeyboxDetail.vue?vue&type=script&lang=js"
export * from "./KeyboxDetail.vue?vue&type=script&lang=js"
import style0 from "./KeyboxDetail.vue?vue&type=style&index=0&id=08256ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08256ce8",
  null
  
)

export default component.exports